import * as z from 'zod'
import {StocksFiltersSchema} from '@/modules/stocks/schemas'
import {SortSchema} from '@cypro/ui/schemas'
import {DiscardReason} from '@cypro/engine/database/schema'
import {DiscardType} from '@cypro/engine/queries'

export const discardTypes = Object.values(DiscardType.enum)

export const DiscardsFiltersSchema = StocksFiltersSchema.extend({
  types: z.array(DiscardType).optional(),
  substances: z.array(z.uuidv7()).optional(),
  reasons: z.array(DiscardReason).optional(),
  createdAtFrom: z.number().optional(),
  createdAtTo: z.number().optional(),
})

export const DiscardsSearchSchema = z.object({
  filters: DiscardsFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'createdAt', desc: true}]),
})
